import React from 'react'

import Spinner from 'client/icons/Spinner'

import styles from './styles.module.css'

export function LoadingSpinner() {
  return (
    <span className={styles.loadingSpinner}>
      <Spinner />
    </span>
  )
}
